import { Typography } from '@mui/material';
import { useCallback } from 'react';

import { Modal } from '@hapvida/hapvida-core-components';

import { UserRedirectsEnum } from '@services/UserService';

import { useRedirectUser } from '@hooks';
import { NoReviewsScreenModal } from '@flows/private/movements/pages/MovementByScreen/components/NoReviewsScreenModal';

import type { ServiceRedirectModalProps } from './types';
import { useMovementMenuOptions, useRedirectModalState } from '../../hooks';
import { ReviewsScreenModal } from '../ReviewsScreenModal';

export function ServiceRedirectModal({
  openModal,
  toggleModal,
}: Readonly<ServiceRedirectModalProps>) {
  const { title = '', redirectEnum } = useRedirectModalState();
  const { reviewsScreenMovementState } = useMovementMenuOptions();

  const { redirectUser } = useRedirectUser();

  const isReviewsScreen =
    redirectEnum === UserRedirectsEnum.REVIEWS_SCREEN_MOVEMENT;

  const handleRedirect = useCallback(async () => {
    if (!redirectEnum) {
      return;
    }

    await redirectUser(redirectEnum);

    toggleModal();
  }, [toggleModal]);

  if (
    isReviewsScreen &&
    !reviewsScreenMovementState?.data?.existsReviewsScreenMovement
  ) {
    return (
      <NoReviewsScreenModal modalState={openModal} toggleModal={toggleModal} />
    );
  }
  if (
    isReviewsScreen &&
    reviewsScreenMovementState?.data?.existsReviewsScreenMovement
  ) {
    return (
      <ReviewsScreenModal modalState={openModal} toggleModal={toggleModal} />
    );
  }

  return (
    <Modal
      type="default"
      icon="actions-b2b-alert-octagon-filled"
      open={openModal}
      handleCloseModal={toggleModal}
      secondaryButtonText="Fechar"
      mainButtonText="Acessar portal"
      mainAction={handleRedirect}
      title={title}
    >
      <Typography variant="text">
        A funcionalidade de{' '}
        <Typography variant="text" fontWeight={700}>
          {title}{' '}
        </Typography>
        estará disponível em breve. Clique em “Acessar portal” para ser
        direcionado para uma nova página.
      </Typography>
    </Modal>
  );
}
